<template>
  <div>
    <ed-campanha :intTipoServicoId="1410" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCampanha from "@/components/campanha/index";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdCampanha },
  mounted() {
  },
  beforeDestroy() {
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
